import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppCommonModule } from '@app/components/app.common.module';
import { QuoteRoutingModule } from './quote-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { NewStandardQuoteComponent } from './standard-quote/new-standard-quote.component';
import { ModelsWrapperComponent } from './standard-quote/models/models-wrapper.component';
import { AccessoriesComponent } from './standard-quote/accessories/accessories.component';
import { AccessoryComponent } from './standard-quote/accessories/accessory/accessory.component';
import { AccessoriesListComponent } from './standard-quote/read-only/accessories-list/accessories-list.component';
import { AccessoryViewComponent } from './standard-quote/read-only/accessories-list/accessory-view/accessory-view.component';
import {
  popperVariation,
  provideTippyConfig,
  provideTippyLoader,
  tooltipVariation,
} from '@ngneat/helipopper/config';
import { FinancialServiceViewDesktopComponent } from '@app/pages/quote/standard-quote/read-only/financial-service-view/desktop/financial-service-view-desktop.component';
import { FinancialServiceViewMobileComponent } from '@app/pages/quote/standard-quote/read-only/financial-service-view/mobile/financial-service-view-mobile.component';
import { ModelsViewDesktopComponent } from '@app/pages/quote/standard-quote/read-only/models-view/desktop/models-view-desktop.component';
import { ModelsViewMobileComponent } from '@app/pages/quote/standard-quote/read-only/models-view/mobile/models-view-mobile.component';
import { ListStandardQuotePageComponent } from '@app/pages/quote/standard-quote/list-quote-standard/list-standard-quote-page.component';
import { ListQuoteStandardWrapperComponent } from '@app/pages/quote/standard-quote/list-quote-standard/list-quote-standard-wrapper.component';
import { ListQuoteStandardDesktopComponent } from '@app/pages/quote/standard-quote/list-quote-standard/desktop/list-quote-standard-desktop.component';
import { ListQuoteStandardMobileComponent } from '@app/pages/quote/standard-quote/list-quote-standard/mobile/list-quote-standard-mobile.component';
import { ClientWrapperComponent } from '@app/pages/quote/standard-quote/client/client-wrapper.component';
import { ClientDesktopComponent } from '@app/pages/quote/standard-quote/client/desktop/client-desktop.component';
import { ClientMobileComponent } from '@app/pages/quote/standard-quote/client/mobile/client-mobile.component';
import { FinancialProductWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/financial-product/financial-product-wrapper.component';
import { FinancialProductDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/financial-product/desktop/financial-product-desktop.component';
import { FinancialProductMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/financial-product/mobile/financial-product-mobile.component';
import { ResultQuoteWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/result/result-wrapper.component';
import { ResultDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/result/desktop/result-desktop.component';
import { ResultMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/result/mobile/result-mobile.component';
import { ModelsDesktopComponent } from '@app/pages/quote/standard-quote/models/desktop/models-desktop.component';
import { ModelsMobileComponent } from '@app/pages/quote/standard-quote/models/mobile/models-mobile.component';
import { NewDealStandardQuotePageComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/new-deal-standard-quote/new-deal-standard-quote-page.component';
import { NewDealStandardQuoteWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/new-deal-standard-quote/new-deal-standard-quote-wrapper.component';
import { NewDealStandardQuoteDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/new-deal-standard-quote/desktop/new-deal-standard-quote-desktop.component';
import { NewDealStandardQuoteMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/new-deal-standard-quote/mobile/new-deal-standard-quote-mobile.component';
import { DealsStandardQuoteWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/deal-standard-quote/deals-standard-quote-wrapper.component';
import { DealsStandardQuoteDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/deal-standard-quote/desktop/deals-standard-quote-desktop.component';
import { DealsStandardQuoteMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/deal-standard-quote/mobile/deals-standard-quote-mobile.component';
import { RowDealStandardQuoteWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/row-deal-standard-quote/row-deal-standard-quote-wrapper.component';
import { RowDealStandardQuoteDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/row-deal-standard-quote/desktop/row-deal-standard-quote-desktop.component';
import { RowDealStandardQuoteMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/row-deal-standard-quote/mobile/row-deal-standard-quote-mobile.component';
import { ViewDealStandardQuoteWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/view-deal-standard-quote/view-deal-standard-quote-wrapper.component';
import { ViewDealStandardQuoteDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/view-deal-standard-quote/desktop/view-deal-standard-quote-desktop.component';
import { ViewDealStandardQuoteMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/view-deal-standard-quote/mobile/view-deal-standard-quote-mobile.component';
import { PaymentsStandardQuoteWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/payments-standard-quote/payments-standard-quote-wrapper.component';
import { PaymentsStandardQuoteDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/payments-standard-quote/desktop/payments-standard-quote-desktop.component';
import { PaymentsStandardQuoteMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/payments-standard-quote/mobile/payments-standard-quote-mobile.component';
import { FinancialServiceStandardWrapperComponent } from '@app/pages/quote/standard-quote/financial-service-standard/financial-service-standard-wrapper.component';
import { FinancialServiceStandardDesktopComponent } from '@app/pages/quote/standard-quote/financial-service-standard/desktop/financial-service-standard-desktop.component';
import { FinancialServiceStandardMobileComponent } from '@app/pages/quote/standard-quote/financial-service-standard/mobile/financial-service-standard-mobile.component';
import { CustomerViewWrapperComponent } from '@app/pages/quote/standard-quote/read-only/customer-view/customer-view-wrapper.component';
import { CustomerViewDesktopComponent } from '@app/pages/quote/standard-quote/read-only/customer-view/desktop/customer-view-desktop.component';
import { CustomerViewMobileComponent } from '@app/pages/quote/standard-quote/read-only/customer-view/mobile/customer-view-mobile.component';
import { ColumnDealStandardWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/column-deal-standard/column-deal-standard-wrapper.component';
import { ColumnDealStandardDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/column-deal-standard/desktop/column-deal-standard-desktop.component';
import { ColumnDealStandardMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/column-deal-standard/mobile/column-deal-standard-mobile.component';
import { ListSpecialPaymentsGracePeriodWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/list-special-payments-grace-period/list-special-payments-gp-wrapper.component';
import { ListSpecialPaymentsGracePeriodDesktopComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/list-special-payments-grace-period/desktop/list-special-payments-gp-desktop.component';
import { ListSpecialPaymentsGracePeriodMobileComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/list-special-payments-grace-period/mobile/list-special-payments-gp-mobile.component';
import { CoverageResultComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/result/result-coverage-marsh/coverage-result.component';
import { QuoteResultComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/result/result-quote/quote-result.component';
import { FinancialServiceViewWrapperComponent } from '@app/pages/quote/standard-quote/read-only/financial-service-view/financial-service-view-wrapper.component';
import { ModelsViewWrapperComponent } from '@app/pages/quote/standard-quote/read-only/models-view/models-view-wrapper.component';
import { SelectClientModalComponent } from '@app/components/client-select-modal/client-select-modal.component';
import { ClientFormModalMobileComponent } from '@app/components/client-form-modal-mobile/client-form-modal-mobile.component';
import { ClientFormModalComponent } from '@app/components/client-form-modal/client-form-modal.component';
import { SelectClientModalMobileComponent } from '@app/components/client-select-modal-mobile/client-select-modal-mobile.component';
import { ConfirmationDialog } from '@app/pages/quote/standard-quote/models/confirmationDialog';
import { InsuranceComponentWrapper } from '@app/pages/quote/insurance/insurance/insurance-wrapper.component';
import { InsuranceDesktopComponent } from '@app/pages/quote/insurance/insurance/desktop/insurance-desktop.component';
import { InsuranceMobileComponent } from '@app/pages/quote/insurance/insurance/mobile/insurance-mobile.component';
import { InsuranceFlexWrapper } from '@app/pages/quote/insurance/insurance-flex/insurance-flex-wrapper.component';
import { InsuranceFlexComponent } from '@app/pages/quote/insurance/insurance-flex/desktop/insurance-flex-desktop.component';
import { InsuranceFlexMobileComponent } from '@app/pages/quote/insurance/insurance-flex/mobile/insurance-flex-mobile.component';
import { PercentageInputDirective } from '@app/directives/value-input.directive';
import { TippyDirective } from '@ngneat/helipopper';

@NgModule({
  imports: [
    TippyDirective,
    CommonModule,
    FormsModule,
    AppCommonModule,
    QuoteRoutingModule,
    TranslateModule,
    SelectClientModalComponent,
    SelectClientModalMobileComponent,
    ClientFormModalComponent,
    ClientFormModalMobileComponent,
    PercentageInputDirective,
  ],
  declarations: [
    ListStandardQuotePageComponent,
    ListQuoteStandardWrapperComponent,
    ListQuoteStandardDesktopComponent,
    ListQuoteStandardMobileComponent,
    NewStandardQuoteComponent,
    ClientWrapperComponent,
    ClientDesktopComponent,
    ClientMobileComponent,
    FinancialProductWrapperComponent,
    FinancialProductDesktopComponent,
    FinancialProductMobileComponent,
    ResultQuoteWrapperComponent,
    ResultDesktopComponent,
    ResultMobileComponent,
    ModelsWrapperComponent,
    ModelsDesktopComponent,
    ModelsMobileComponent,
    AccessoriesComponent,
    NewDealStandardQuotePageComponent,
    NewDealStandardQuoteWrapperComponent,
    NewDealStandardQuoteDesktopComponent,
    NewDealStandardQuoteMobileComponent,
    DealsStandardQuoteWrapperComponent,
    DealsStandardQuoteDesktopComponent,
    DealsStandardQuoteMobileComponent,
    RowDealStandardQuoteWrapperComponent,
    RowDealStandardQuoteDesktopComponent,
    RowDealStandardQuoteMobileComponent,
    ViewDealStandardQuoteWrapperComponent,
    ViewDealStandardQuoteDesktopComponent,
    ViewDealStandardQuoteMobileComponent,
    PaymentsStandardQuoteWrapperComponent,
    PaymentsStandardQuoteDesktopComponent,
    PaymentsStandardQuoteMobileComponent,
    FinancialServiceStandardWrapperComponent,
    FinancialServiceStandardDesktopComponent,
    FinancialServiceStandardMobileComponent,
    CustomerViewWrapperComponent,
    CustomerViewDesktopComponent,
    CustomerViewMobileComponent,
    ColumnDealStandardWrapperComponent,
    ColumnDealStandardDesktopComponent,
    ColumnDealStandardMobileComponent,
    ListSpecialPaymentsGracePeriodWrapperComponent,
    ListSpecialPaymentsGracePeriodDesktopComponent,
    ListSpecialPaymentsGracePeriodMobileComponent,
    CoverageResultComponent,
    QuoteResultComponent,
    FinancialServiceViewWrapperComponent,
    FinancialServiceViewDesktopComponent,
    FinancialServiceViewMobileComponent,
    ModelsViewWrapperComponent,
    ModelsViewDesktopComponent,
    ModelsViewMobileComponent,
    AccessoryComponent,
    AccessoriesListComponent,
    AccessoryViewComponent,
    InsuranceComponentWrapper,
    InsuranceDesktopComponent,
    InsuranceMobileComponent,
    InsuranceFlexWrapper,
    InsuranceFlexComponent,
    InsuranceFlexMobileComponent,
    ConfirmationDialog
  ],
  providers: [
    provideTippyConfig({
      defaultVariation: 'tooltip',
      variations: {
        tooltip: tooltipVariation,
        popper: popperVariation,
      },
      duration: [null, 0],
      delay: [200, 0],
    }),
    provideTippyLoader(() => import('tippy.js')),
  ],
})
export class QuoteModule {}
